import About from './components/About';
import Footer from './components/Footer';
import Header from './components/Header';
import HeadlineFlex from './components/HeadlineFlex';
import ProjectList from './components/ProjectList';

function App() {
  return (
    <>
      <Header />
      <HeadlineFlex />
      <ProjectList />
      <About />
      <Footer />
    </>
  );
}

export default App;
